interface Props {
    title: string;
    description: string;
}

export default function AddRequestHeader({ title, description }: Props) {
    return (
        <div className="space-y-2">
            <h2 className="text-[20px] font-poppins font-semibold  text-black">{title}</h2>
            <p className="text-base font-normal text-light-black/80">{description}</p>
        </div>
    );
}
